import { Component, OnInit } from '@angular/core';
import { CarrerasService } from 'src/app/services/carreras.service';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { InstitucionesService } from 'src/app/services/instituciones.service';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-carreras',
  templateUrl: './carreras.component.html',
  styleUrls: ['./carreras.component.scss']
})
export class CarrerasComponent implements OnInit {

  carreras:any[] = [];
  private respuestaCarreras : any;
  buscar: any;

  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  respuestaAgregar:any;
  respuestaEditar:any;
  respuestaUpdate:any;
  respuestaInstituciones:any;
  escuelas;

  datosItem;
  itemId;
  data;

  formulario;
  formularioEdit;
  escuelaSelected;

  constructor(private _getCarreras : CarrerasService, private _agregarCarrera: CatalogosService, private _editarCarrera:CatalogosService,
    private _updateCarrera: CatalogosService, private modalService: NgbModal, private iziToast: Ng2IzitoastService,
    private _getInstituciones: InstitucionesService) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      pageLength: 20,
      processing: true
    };
    
    this.getCarreras();
    this.getEscuelas();
    this.formulario = {
      'nombre':'',
    }

    this.formularioEdit = {
      'nombre':'',
    }
  }

  getCarreras(){
    this._getCarreras.getCarreras().subscribe(
      data => {
        this.respuestaCarreras = data;
        if(this.respuestaCarreras.success){
          this.carreras = this.respuestaCarreras.content;
          this.dtTrigger.next();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  getEscuelas(){
    this._getInstituciones.getInstituciones().subscribe(
      data => {
        this.respuestaInstituciones = data;
        if(this.respuestaInstituciones.success){
          this.escuelas = this.respuestaInstituciones.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  agregarCarrera(){
    this.data = {
      'nombre': this.formulario.nombre,
      // 'institucion': escuela,
    }

    this._agregarCarrera.agregarCarrera(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el pago correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getCarreras();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  editarCarrera(carrera){
    this.data = {
      'carrera':carrera,
    }
    this._editarCarrera.editarCarrera(this.data).subscribe(
      data => {
        this.respuestaEditar= data;
        if(this.respuestaEditar.success){
          this.datosItem = this.respuestaEditar.content;
          this.formularioEdit.nombre = this.datosItem.nombre;
          this.itemId = carrera;
          this.escuelaSelected =  this.datosItem.escuelaid;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateCarrera(carrera){
    this.data = {
      'carrera': carrera, 
      // 'institucion': escuela, 
      'nombre': this.formularioEdit.nombre,
    }

    this._updateCarrera.updateCarrera(this.data).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getCarreras();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }
  

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }
}
